import { createContext, useContext, useState, useCallback } from 'react';

const AppHeaderContext = createContext(null);

export const useAppHeader = () => useContext(AppHeaderContext);

export const AppHeaderProvider = ({ children }) => {
  const [centerContent, setCenterContent] = useState(null);
  const [rightContent, setRightContent] = useState(null);
  const [showBackButton, setShowBackButton] = useState(false);

  const setHeaderCenter = useCallback((content) => {
    setCenterContent(content);
  }, []);

  const setHeaderRight = useCallback((content) => {
    setRightContent(content);
  }, []);

  const setHeaderBackButton = useCallback((show) => {
    setShowBackButton(!!show);
  }, []);

  return (
    <AppHeaderContext.Provider
      value={{
        centerContent,
        setHeaderCenter,
        rightContent,
        setHeaderRight,
        showBackButton,
        setHeaderBackButton,
      }}
    >
      {children}
    </AppHeaderContext.Provider>
  );
};
